import * as React from 'preact/compat'
import { TelegramShareButton, TwitterShareButton, BlueskyShareButton, VKShareButton, WhatsappShareButton } from 'react-share'
import useragent from '../common/useragent'
import alertCss from '../../css/sg-alert.pcss.json'
import buttonsCss from '../../css/buttons.pcss.json'
import Modal from '../components/Modal'
import SVG from '../components/SVG'
import { loadStylesheet, showModal } from '../common/helpers'
import { showToast } from '../components/toast'

const networks: Array<{
  name: string,
  component: React.FC<any>,
  title?: string,
  icon?: React.FC<any>
}> = [
  {
    component: VKShareButton,
    name: 'vk',
  },
  {
    component: TwitterShareButton,
    name: 'twitter'
  },
  {
    component: BlueskyShareButton,
    name: 'bluesky'
  },
  {
    component: TelegramShareButton,
    name: 'telegram'
  },
  {
    component: WhatsappShareButton,
    name: 'whatsapp'
  }
]

interface ShareDialogProps {
  url: string,
  image: string,
  title: string,
  description: string,
  onClose: () => void
}

const ShareDialog: React.FC<ShareDialogProps> = ({ onClose, url, image, title, description }) => {

  React.useEffect(() => {
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('buttons')
  }, [])

  const copyLink = () => {
    window.navigator.clipboard.writeText(url)
      .then(() => {
        showToast({
          text: 'Ссылка скопирована в буфер обмена',
          type: 'success',
        })
        onClose()
      })
  }

  const buttons = []

  networks.forEach(social => {
    const icon = social.icon ? <social.icon/> : <SVG i={`auth/${social.name}`}/>
    const Component = social.component

    buttons.push(<Component
      className={alertCss['auth-social-button']}
      resetButtonStyle={false}
      url={url}
      title={title}
      description={description}
      image={image}
      related={['@stopgameru']}
    >
      {icon}
    </Component>)
  })

  return <Modal showClose onClose={onClose}>
    <div className={alertCss['share-container']}>
      <p className={alertCss['share-header']}>Поделиться</p>
      <button className={buttonsCss['gray']} onClick={copyLink} style='--button-icon-size: 24px'>
        <SVG i='sg-new/copy' adaptive/> Скопировать ссылку
      </button>
      <div className={alertCss['socials-grid']}>
        {buttons}
      </div>
    </div>
  </Modal>
}

const showShareDialog = () => {
  const title = document.querySelector('title').innerText
  const description = document.querySelector('meta[name="description"]')?.getAttribute('content') || ''
  const meta = document.querySelector('meta[property="vk:image"]')
  const image = meta ? meta.getAttribute('content') : ''
  const url = window.location.href

  if (window.navigator.share && !useragent.isDesktopOS) {
    // noinspection JSIgnoredPromiseFromCall
    window.navigator.share({
      title,
      text: description,
      url
    })
    return
  }

  showModal(ShareDialog, {
    url,
    image,
    title,
    description
  })
}

// noinspection JSUnusedGlobalSymbols
export default (elements: NodeListOf<HTMLElement>) => {
  elements.forEach(element => {
    element.addEventListener('click', showShareDialog)
  })
}
